import { ForestCrewContextProvider } from '@features/Contractor/ForestCrew/ForestCrewContext'
import { getForestCrewQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const ForestCrewLayout: React.FC = () => {
  const { contractorId, forestCrewId } = Route.useParams()
  const { data, isLoading, isError, refetch } = useQuery(
    getForestCrewQuery(contractorId, forestCrewId),
  )

  const handleRefetch = () => {
    void refetch()
  }

  return (
    <ForestCrewContextProvider value={{ data, isLoading, isError, refetch: handleRefetch }}>
      <Outlet />
    </ForestCrewContextProvider>
  )
}

export const Route = createFileRoute('/contractor/$contractorId/forest-crews/$forestCrewId')({
  component: ForestCrewLayout,
  staticData: {
    breadcrumb: t('contractor.forestCrew.edit.title'),
  },
})
